import React from "react";
import whyNowImg from "assets/products/dto/dto-why-now.webp";

interface WhyNowProps {
    className?: string;
}

const WhyNow = ({ className = "" }: WhyNowProps) => {
    return (
        <div className={`flex flex-col tablet:relative w-full overflow-hidden tablet:h-[648px] ${className}`}>
            <img
                src={whyNowImg}
                alt="Why Now background"
                className="w-full h-[300px] tablet:absolute tablet:inset-0 tablet:h-full object-cover -scale-x-100"
            />
            {/* Content wrapper with max-width */}
            <div className="w-full max-w-[1200px] mx-auto tablet:absolute tablet:inset-0 tablet:flex tablet:items-center">
                <div className="relative w-full tablet:bg-slate-900 bg-slate-900 tablet:w-fit flex items-center h-auto tablet:rounded-tr-3xl tablet:rounded-br-3xl tablet:rounded-tl-none tablet:rounded-bl-none large:rounded-tl-3xl large:rounded-bl-3xl rounded-t-3xl py-5 px-5 tablet:py-6 tablet:px-6 mt-[-2rem] tablet:mt-0 z-10 tablet:before:content-[''] tablet:before:absolute tablet:before:inset-y-0 tablet:before:right-full tablet:before:left-[-100vw] tablet:before:bg-slate-900 large:before:content-none">
                    <div className="max-w-full w-full tablet:max-w-[540px]">
                        <h2 className="mb-6 text-white tablet:text-5xl text-3xl font-normal leading-none font-sans text-center tablet:text-left">
                            Why Now?
                        </h2>
                        <p className="text-white tablet:text-medium text-sm tablet:leading-6 leading-5 font-normal font-sans">
                            As you age, health issues can make it tougher to secure coverage. Your employer's policy might not
                            be sufficient—or could vanish if you change jobs. Whether you need to supplement existing coverage
                            or plan for inflation and changing circumstances, applying now for Direct Term Life Insurance is a
                            smart, forward-thinking decision.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyNow;
